import {
    dehydrate,
    DehydratedState,
    QueryClient,
    useQuery,
} from "@tanstack/react-query";
import type { GetServerSideProps, NextPage } from "next";
import Seo from "@/components/common/Seo";
import AuthProvider from "@/components/common/AuthProvider";
import { ESeoPage } from "@/utils/mockData/metaMocks";

import { withRedirect } from "@/utils/redirects";
import { getBrochureData, getNavBarData, getSeoInfo } from "../utils/queries";
import BookingBody from "../components/account/booking/BookingBody";

const Booking: NextPage = () => {
    const { data: metaTags } = useQuery({
        queryKey: ["metaTags", ESeoPage.BOOKINGS],
        queryFn: () => getSeoInfo(ESeoPage.BOOKINGS),
    });

    return (
        <>
            <Seo seoInfo={metaTags!} />
            <AuthProvider>
                <BookingBody />
            </AuthProvider>
        </>
        // </Layout>
    );
};

export const getServerSideProps: GetServerSideProps = withRedirect(
    async (): Promise<{
        props: {
            dehydratedState: DehydratedState;
        };
    }> => {
        const queryClient = new QueryClient();

        await Promise.all([
            await queryClient.prefetchQuery(["navBar"], getNavBarData),
            await queryClient.prefetchQuery(["brochures"], getBrochureData),
            await queryClient.prefetchQuery(
                ["metaTags", ESeoPage.BOOKINGS],
                () => getSeoInfo(ESeoPage.BOOKINGS)
            ),
        ]);

        return {
            props: {
                dehydratedState: dehydrate(queryClient),
            },
        };
    }
);

export default Booking;
